import React, { Suspense } from "react"
import { Button, Spinner } from "reactstrap"
import { METRIC_LABELS } from "utils/afghanistanProvinceMap"

const AfghanistanProvinceMapChart = React.lazy(() =>
  import("./charts/AfghanistanProvinceMapChart")
)

const MAP_TYPES = [
  { id: "receipt", label: "Receipt" },
  { id: "distribution", label: "Distribution" },
]

const AfghanistanProvinceMapPanel = ({
  data,
  loading,
  error,
  mapType,
  onTypeChange,
  onProvinceClick,
}) => {
  const metricLabel = METRIC_LABELS[mapType] || mapType
  const provinces = data?.provinces || []
  const totalQuantity = data?.total_quantity ?? 0
  const hasData = Boolean(data?.has_data)

  if (loading) {
    return (
      <div>
        <div className="d-flex flex-wrap gap-2 align-items-center mb-3">
          <span className="text-muted">Show:</span>
          {MAP_TYPES.map(type => (
            <Button
              key={type.id}
              size="sm"
              color={mapType === type.id ? "primary" : "light"}
              disabled={loading}
              onClick={() => onTypeChange(type.id)}
            >
              {type.label}
            </Button>
          ))}
        </div>
        <div className="text-center py-5">
          <Spinner />
          <div className="text-muted mt-2">Loading {metricLabel.toLowerCase()} data...</div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger mb-0">
        Unable to load province map data. Please try again.
      </div>
    )
  }

  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <span className="text-muted">Show:</span>
          {MAP_TYPES.map(type => (
            <Button
              key={type.id}
              size="sm"
              color={mapType === type.id ? "primary" : "light"}
              onClick={() => onTypeChange(type.id)}
            >
              {type.label}
            </Button>
          ))}
        </div>
        <div className="text-end">
          <div className="text-muted small">Total {metricLabel} Quantity</div>
          <h4 className="mb-0">{totalQuantity.toLocaleString()}</h4>
        </div>
      </div>

      <Suspense
        fallback={
          <div className="text-center py-5">
            <Spinner />
          </div>
        }
      >
        <AfghanistanProvinceMapChart
          data={provinces}
          metric={mapType}
          totalQuantity={totalQuantity}
          onProvinceClick={onProvinceClick}
        />
      </Suspense>
    </div>
  )
}

export default AfghanistanProvinceMapPanel
